/** Clase que aplica la lectura de los valores de utm enviados por parámetro en el url */
class ReadUTM {
    /**
     * Extrae los valores enviados por parámetros en el url
     * @return {array} params - lista de parámetros contenidos en el url
     */
    getVars() {
        const params = [];
        window.location.search
            .replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
                const temp = {};
                temp['key'] = key;
                temp['value'] = value;
                params.push(temp);
            });
        return params;
    }

    /**
     * Concatena el href del botón con la lista de parámetros del url
     * @param   {string}  href  - valor href del botón
     * @param   {array}   vars  - lista con los valores de los parámetros del url
     * @return  {string}        - nuevo valor del href para el botón
     */
    concatUTM(href, vars) {
        const newString = vars.map((item) => {
            return `${item['key']}=${item['value']}`;
        })
        const queryString = newString.join("&");
        if (newString.length >= 1) {
            if (href.indexOf('?') != -1) {
                return `${href}&${queryString}`;
            } else {
                return `${href}?${queryString}`;
            }
        } else {
            return `${href}`;
        }

    }

    /**
     * Extrae el href del botón
     * @return {string} - valor del href del botón
     */
    readHref() {
        const $item = $('a.btn[data-read-utm="true"]').eq(0);
        return $item.attr('href');
    }

    /**
     * Constructor de la clase
     * @return {void}
     */
    constructor() {
        const url = this.readHref();
        const vars = this.getVars();
        const newString = this.concatUTM(url, vars);
        $('a.btn[data-read-utm="true"]').attr('href', newString);
    }
}


// ----------------------------------------------------------------------
/**
 * Definición del document ready de jquery
 * @return  {void}
 */
$(document).ready(function() {
    const readUTM = new ReadUTM();
})